import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import TopNavigation from '../../TopNavigation'
import withAppconfig from '../../AppContext'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import ProductCard from '../../components/Shop/ProductCard'
import { Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const mapStateToProps = (state, props) => {
  const { firebase } = state
  console.log('firebase ordered gifts:', firebase.ordered)
  if (!firebase.ordered.shopgifts) return { gifts: null }
  const gifts = firebase.ordered.shopgifts.map((m) => {
    return { id: m.key, ...m.value }
  })
  return {
    gifts,
  }
}

const withProducts = compose(
  firebaseConnect((props) => [
    {
      path: 'shop/' + props.appconfig.accountkey + '/giftcards',
      queryParams: ['orderByChild=displayName'],
      storeAs: 'shopgifts',
    },
  ]),
  connect(mapStateToProps)
)

function GiftsScreen({ appconfig, gifts }) {
  const { t } = useTranslation()
  const hasGifts = gifts && gifts.length > 0

  return (
    <div className='full-page-background'>
      <TopNavigation />
      <Container className='front' style={{ paddingTop: 10 }}>
        <Typography variant='h6' style={{ paddingBottom: 20 }}>
          {t('giftcards')} {hasGifts ? `(${gifts.length})` : '0' }
        </Typography>
        {hasGifts ? (
          <Row>
            {gifts.map((m) => (
              <Col key={m.id} xs={12} sm={4}>
                <ProductCard
                  product={m}
                  collection={'gift'}
                  isAuthRequired={false}
                />
              </Col>
            ))}
          </Row>
        ) : null}
      </Container>
    </div>
  )
}

export default withAppconfig(withProducts(GiftsScreen))
